import { render, staticRenderFns } from "./notionScreen.vue?vue&type=template&id=affce154&scoped=true&"
import script from "./notionScreen.vue?vue&type=script&lang=js&"
export * from "./notionScreen.vue?vue&type=script&lang=js&"
import style0 from "./notionScreen.vue?vue&type=style&index=0&id=affce154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affce154",
  null
  
)

export default component.exports